<template>
  <div class="content">
    <div class="main">
      <Row>
      <Col span="5"></Col>
      <Col span="24" :md="12">
        <Form ref="formItem" :model="formItem" :rules="ruleValidate" :label-width="100">
          <FormItem  label="项目名(中文)" prop="name">
            <Input  v-model="formItem.name" placeholder="输入项目中文名称"></Input>
          </FormItem>
          <FormItem  label="项目名(英文)" prop="name_en">
            <Input   v-model="formItem.name_en" placeholder="输入项目英文名称"></Input>
          </FormItem>
          <FormItem  label="项目经理" prop="masters">
             <Select  v-model="formItem.masters"  multiple>
              <Option  v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></Option>
             </Select>
          </FormItem>
          <FormItem  label="产品经理" prop="pms">
             <Select  v-model="formItem.pms"  multiple>
              <Option  v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></Option>
             </Select>
          </FormItem>
           <FormItem  label="开发人员" prop="developers">
             <Select  v-model="formItem.developers"  multiple>
              <Option  v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></Option>
             </Select>
          </FormItem>
           <FormItem  label="测试人员" prop="tests">
             <Select  v-model="formItem.tests"  multiple>
              <Option  v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></Option>
             </Select>
          </FormItem>
          <FormItem  label="维护人员" prop="maintain">
             <Select  v-model="formItem.maintain"  multiple>
              <Option  v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></Option>
             </Select>
          </FormItem>
           <FormItem  label="项目描述" prop="description" >
            <Input  v-model="formItem.description" placeholder="请输入项目描述信息" type="textarea"></Input>
          </FormItem>
        <FormItem>
            <Button type="primary" @click="doSubmit('formItem')">修改</Button>
        </FormItem>
    </Form>
    </Col>
    </Row>
</div></div>
</template>
<script>
import { GetALLUsers } from '@/api/user'
export default {
  name: 'ProjectForm',
  components: {
  },
  props:
    {
      'data': Object,
      'type': {
        type: String,
        required: true
      },
      'handleSubmit': {
        type: Function
      }
    },
  data () {
    return {
      data_own: {},
      user_all: [],
      formItem: {
        name: '',
        name_en: '',
        masters: [],
        pms: [],
        developers: [],
        tests: [],
        maintain: [],
        description: ''
      },
      ruleValidate: {
        name: [{ required: true, message: '项目名(中文)不能为空 !', trigger: 'blur' }],
        name_en: [{ required: true, message: '项目名(英文)不能为空 !', trigger: 'blur' }],
        masters: [
          { required: true, message: '项目经理不能为空 !', trigger: 'change', type: 'array' }
        ],
        developers: [
          { required: true, message: '开发人员不能为空 !', trigger: 'change', type: 'array' }
        ]
      }
    }
  },
  watch: {
    data () {
      this.data_own = this.data
      this.formItem.name = this.data.name
      this.formItem.name_en = this.data.name_en
      this.formItem.masters = this.data.masters
      this.formItem.pms = this.data.pms
      this.formItem.developers = this.data.developers
      this.formItem.tests = this.data.tests
      this.formItem.maintain = this.data.maintain
      this.formItem.description = this.data.description
    }
  },
  methods: {
    fetchAllUserData () {
      GetALLUsers().then(res => {
        this.user_all = res.data
      })
    },
    doSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.handleSubmit(this.formItem)
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
      })
    }
  },
  mounted: function () {
    this.fetchAllUserData()
  }
}
</script>
